import builder from '../builder';
import MessagesBubbleSquareTyping1 from '../../streamline-icons/bold/messages-bubble-square-typing-1.svg';

export default builder(
  'IconMessagesBubbleSquareTyping1Bold',
  MessagesBubbleSquareTyping1,
);
